import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OCC_ENDPOINTS, PersonalManager, PersonalManagersList } from '@my-account/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PersonalManagerApiService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  getInfo(userId: string): Observable<PersonalManager> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.personalManager, {
      urlParams: { userId },
    });

    return this.http.get<PersonalManager>(url, {
      headers,
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.personalManager),
    });
  }

  approveManager(uid: string): Observable<unknown> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.approvePersonalManager, {
      urlParams: { uid },
    });

    return this.http.post<void>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.approvePersonalManager),
    });
  }

  revokeManager(uid: string): Observable<unknown> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.revokePersonalManager, {
      urlParams: { uid },
    });

    return this.http.post<void>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.revokePersonalManager),
    });
  }

  deleteManager(uid: string): Observable<unknown> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.deletePersonalManager, {
      urlParams: { uid },
    });

    return this.http.post<void>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.deletePersonalManager),
    });
  }

  loadList(): Observable<PersonalManagersList> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.personalManagers);

    return this.http.get<PersonalManagersList>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.personalManagers),
    });
  }
}
